
import React from 'react';
import { ButtonInfo } from '../hooks/useJobButtonInfo';

interface Props {
    buttonInfo: ButtonInfo;
    onAction: (action: string) => void;
}

export const ActionButtons: React.FC<Props> = ({ buttonInfo, onAction }) => {
    if (buttonInfo.action === 'adjustDecision') {
        return (
            <div className="bottom-btn">
                <button className="btn cancel" onClick={() => onAction('adjustReject')}>조정 거절</button>
                <button className="btn confirm" onClick={() => onAction('adjustApprove')}>조정 승인</button>
            </div>
        );
    }
    if (buttonInfo.text === '버튼 없음' || !buttonInfo.action) return null;
    return (
        <div className="bottom-btn">
            <button className="btn confirm" onClick={() => onAction(buttonInfo.action!)}>
                {buttonInfo.text}
            </button>
        </div>
    );
};